module.exports = __webpack_public_path__ + "img/create_virtual_pub.359d7173.png";